"use strict";
/*
 * Created on 03 20 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceStickersWeekReportDTO_1 = require("../model/PriceStickersWeekReportDTO");

var PriceStickersWeekReportDTOConverter_1 = require("./PriceStickersWeekReportDTOConverter");
/**
 * @author Jaroslav Sevcik
 */


var PriceStickersWeekReportDTOConverterImpl =
/*#__PURE__*/
function (_PriceStickersWeekRep) {
  _inherits(PriceStickersWeekReportDTOConverterImpl, _PriceStickersWeekRep);

  function PriceStickersWeekReportDTOConverterImpl() {
    _classCallCheck(this, PriceStickersWeekReportDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceStickersWeekReportDTOConverterImpl).apply(this, arguments));
  }

  _createClass(PriceStickersWeekReportDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PriceStickersWeekReportDTO_1.PriceStickersWeekReportDTO(PriceStickersWeekReportDTO_1.PriceStickersWeekReportDTO.schema.priceListTypeId.valueOf(source.priceListTypeId), PriceStickersWeekReportDTO_1.PriceStickersWeekReportDTO.schema.priceCodeId.valueOf(source.priceCodeId), PriceStickersWeekReportDTO_1.PriceStickersWeekReportDTO.schema.mondayRepricingCount.valueOf(source.mondayRepricingCount), PriceStickersWeekReportDTO_1.PriceStickersWeekReportDTO.schema.tuesdayRepricingCount.valueOf(source.tuesdayRepricingCount), PriceStickersWeekReportDTO_1.PriceStickersWeekReportDTO.schema.wednesdayRepricingCount.valueOf(source.wednesdayRepricingCount), PriceStickersWeekReportDTO_1.PriceStickersWeekReportDTO.schema.thursdayRepricingCount.valueOf(source.thursdayRepricingCount), PriceStickersWeekReportDTO_1.PriceStickersWeekReportDTO.schema.fridayRepricingCount.valueOf(source.fridayRepricingCount));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        priceListTypeId: source.priceListTypeId,
        priceCodeId: source.priceCodeId,
        mondayRepricingCount: source.mondayRepricingCount,
        tuesdayRepricingCount: source.tuesdayRepricingCount,
        wednesdayRepricingCount: source.wednesdayRepricingCount,
        thursdayRepricingCount: source.thursdayRepricingCount,
        fridayRepricingCount: source.fridayRepricingCount
      };
    }
  }]);

  return PriceStickersWeekReportDTOConverterImpl;
}(PriceStickersWeekReportDTOConverter_1.PriceStickersWeekReportDTOConverter);

exports.PriceStickersWeekReportDTOConverterImpl = PriceStickersWeekReportDTOConverterImpl;